export default "__VITE_ASSET__BtHwpS3p__"